import { EleitorDTO } from "./eleitorDTO.model";

export class Page  {

   
    content: Array<EleitorDTO>;
    totalPages: number;
    totalElements: number;
    last: boolean;
    first: boolean;
    size: number;
    number: number;
    sort?: any;
    numberOfElements: number;
    

}
 
